import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { FeaturesSection } from './components/FeaturesSection';
import { GallerySection } from './components/GallerySection';
import { PricingSection } from './components/PricingSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#0B0B15] text-white selection:bg-fuchsia-500/30" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <FeaturesSection data-id="element-5" />
        <GallerySection data-id="element-6" />
        <PricingSection data-id="element-7" />
        <HowItWorksSection data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}